"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const merge = (target, source) => {
    if (!source || !target)
        return target;
    for (const key of Object.keys(source)) {
        if (source[key] instanceof Object) {
            Object.assign(source[key], merge(target[key], source[key]));
        }
    }
    Object.assign(target || {}, source);
    return target;
};
exports.default = merge;
